import { Serializable, SerializationHelper } from "@/helpers/SerializationHelper";
import { PreparationOrder } from "@/model/preparation/PreparationOrder";

export class PreparationOrdersBreakdown implements Serializable {
    ordersToProcess: PreparationOrder[];
    ordersProcessed: PreparationOrder[];
    ordersArchived: PreparationOrder[];
    
    fromJSON(rawObject: any): void {
        if (rawObject['ordersToProcess'] != null) {
            this.ordersToProcess = SerializationHelper.toArrayInstanceFromJsonObjArray(() => new PreparationOrder(), rawObject['ordersToProcess']);
        }
        if (rawObject['ordersProcessed'] != null) {
            this.ordersProcessed = SerializationHelper.toArrayInstanceFromJsonObjArray(() => new PreparationOrder(), rawObject['ordersProcessed']);
        }
        if (rawObject['ordersArchived'] != null) {
            this.ordersArchived = SerializationHelper.toArrayInstanceFromJsonObjArray(() => new PreparationOrder(), rawObject['ordersArchived']);
        }
    }
}
